import { useState, useEffect, useRef } from "react";
import Button from "components/atoms/Button";
import axios from "axios";
import lang from "./lang";

import PaymentDetailsForm from "components/molecules/PaymentDetailsForm";
import OrderPackageTable from "components/molecules/OrderPackageTable";

import "./styles.scss";
import { checkouts, products } from "./helpers";

const Order = ({ globals, authUser }) => {
  const defaultPaymentMethod = checkouts[0];
  const paymentForm = useRef();
  const [orderPackage, setOrderPackage] = useState(
    `${authUser?.isSpecialOfferValid ? "fullCourseSpecialOffer" : "fullCourse"}`
  );
  const [orderPackageId, setOrderPackageId] = useState(
    products(globals)[orderPackage]?.id || ""
  );
  const [paymentMethod, setPaymentMethod] = useState(defaultPaymentMethod);
  const [phone, setPhone] = useState(authUser?.phone);
  const [isPhonePristine, setIsPhonePristine] = useState(true);
  const [interkassaAmount, setInterkassaAmount] = useState(
    products(globals)[orderPackage]?.price || 0
  );
  const [interkassaProductName, setInterkassaProductName] = useState(
    products(globals)[orderPackage]?.name || ""
  );
  const [isLoading, setIsLoading] = useState(false);
  const isCard =
    paymentMethod?.name !== "privat24" &&
    paymentMethod?.name !== "transfer" &&
    paymentMethod?.name !== "test";
  const [rebusOrderNumber, setRebusOrderNumber] = useState(null);
  const [interkassaOrderNumber, setInterkassaOrderNumber] = useState(null);
  const [interkassaEncodedOrderData, setInterkassaEncodedOrderData] =
    useState(null);

  const isPhoneValid = () => {
    if (!phone) return false;
    return phone.length >= 10 && phone.length <= 15;
  };
  const isCardValid = () => {
    let isThisCardValid = false;
    if (
      paymentMethod?.name === "visa" ||
      paymentMethod?.name === "mastercard" ||
      !isCard
    )
      isThisCardValid = true;
    return isThisCardValid;
  };
  const handleSubmit = async () => {
    isPhonePristine && setIsPhonePristine(false);
    if (!isPhoneValid()) return;

    const ikProductName = products(globals)[orderPackage]?.name || "";
    setInterkassaProductName(ikProductName);
    const ikAmount = products(globals)[orderPackage]?.price || 0;
    setInterkassaAmount(ikAmount);
    setIsLoading(true);

    const announcementOverlay = document.getElementById("announcement-overlay");
    if (document.body.firstChild !== announcementOverlay) {
      announcementOverlay.remove();
      document.body.insertBefore(announcementOverlay, document.body.firstChild);
    }

    try {
      // Step 1: Generate the order number
      const newOrderNumberResponse = await axios.get(
        "https://us-central1-rebus-gatsby.cloudfunctions.net/generateOrderNumber",
        {
          params: {
            userId: authUser.email,
            normalName: authUser.normalName,
            phone,
            orderPrice: ikAmount,
            paymentMethod: paymentMethod?.ikPaymentMethod,
            orderPackageId,
            interkassaProductName: ikProductName,
          },
        }
      );

      const newOrderNumber = newOrderNumberResponse?.data?.orderNumber;
      setRebusOrderNumber(newOrderNumber);

      const interkassaOrderNum = `${
        products(globals)[orderPackage]?.productNumber[paymentMethod?.name]
      }-${Date.now()}-${newOrderNumber}`;

      setInterkassaOrderNumber(interkassaOrderNum);

      const orderData = {
        lessons_order: orderPackageId || "",
        order_number: newOrderNumber || "",
        phone: `${phone}:${authUser?.email || ""}`,
      };
      const encodedOrderData = btoa(JSON.stringify(orderData));
      setInterkassaEncodedOrderData(encodedOrderData);

      if (paymentMethod?.ikPaymentMethod === "card") {
        // Step 2: Prepare payment data for signature generation
        const paymentData = {
          ik_co_id: paymentMethod?.checkoutId || "",
          ik_payment_method: paymentMethod?.ikPaymentMethod || "",
          ik_payment_currency: globals?.prices?.currency || "",
          ik_cur: globals?.prices?.currency || "",
          ik_am: ikAmount.toString(),
          ik_pm_no: interkassaOrderNum,
          ik_desc: ikProductName,
          ik_loc: "uk_ua",
          ik_cli: phone || "",
          ik_int: "web",
          ik_customer_email: authUser?.email || "",
          ik_customer_phone: `${phone}:${authUser?.email || ""}`,
          ik_customer_referrer: encodedOrderData,
          ik_act: "process",
          ik_ia_u: globals?.payments?.ik_ia_u || "",
          ik_ia_m: globals?.payments?.ik_ia_m || "",
          ik_suc_u: globals?.payments?.ik_suc_u || "",
          ik_result_url: globals?.payments?.ik_suc_u || "",
          ik_pnd_u: globals?.payments?.ik_suc_u || "",
          ik_fal_u: globals?.payments?.ik_fal_u || "",
        };

        // Step 3: Get signature from Firebase function
        const signatureResponse = await axios.get(
          "https://us-central1-rebus-gatsby.cloudfunctions.net/generateTranzzoSign",
          { params: paymentData }
        );

        // Step 4: Add signature to the form
        if (signatureResponse?.data?.signature) {
          const signatureField = document.createElement("input");
          signatureField.type = "hidden";
          signatureField.name = "ik_sign";
          signatureField.value = signatureResponse.data.signature;
          paymentForm.current.appendChild(signatureField);

          // Step 5: Submit the payment form
          setTimeout(() => {
            debugger;
            paymentForm?.current?.submit();
          }, 100);
        } else {
          throw new Error("Failed to generate signature");
        }
      } else {
        // For non-card payment methods
        announcementOverlay.innerHTML = lang?.paymentDetails(
          newOrderNumber,
          globals.contactPhoneNumber
        );
      }
    } catch (error) {
      console.error("Payment error:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setOrderPackageId(products(globals)[orderPackage]?.id || "");
  }, [orderPackage, globals]);

  return (
    <div className="order">
      <OrderPackageTable
        products={products(globals)}
        isLoading={isLoading}
        orderPackage={orderPackage}
        setOrderPackage={setOrderPackage}
        authUser={authUser}
      />
      <PaymentDetailsForm
        isLoading={isLoading}
        isCard={isCard}
        isCardValid={isCardValid}
        isPhonePristine={isPhonePristine}
        isPhoneValid={isPhoneValid}
        paymentMethod={paymentMethod}
        setPaymentMethod={setPaymentMethod}
        phone={phone}
        setPhone={setPhone}
        checkouts={checkouts}
        defaultPaymentMethod={defaultPaymentMethod}
        authUser={authUser}
        globals={globals}
      />

      <form
        ref={paymentForm}
        action="https://paygate.tranzzo.com/"
        method="post"
        target="_top"
        className="flex"
      >
        {/* ID каси Інтеркаси/Finexpress */}
        <input
          type="hidden"
          name="ik_co_id"
          value={paymentMethod?.checkoutId || ""}
        />
        {/* Спосіб оплати: card або uabanking(?) */}
        <input
          type="hidden"
          name="ik_payment_method"
          value={paymentMethod?.ikPaymentMethod || ""}
        />
        {/* Валюта */}
        <input
          type="hidden"
          name="ik_payment_currency"
          value={globals?.prices?.currency || ""}
        />
        <input
          type="hidden"
          name="ik_cur"
          value={globals?.prices?.currency || ""}
        />
        {/* Сума оплати */}
        <input type="hidden" name="ik_am" value={interkassaAmount || ""} />
        {/* Номер замовлення */}
        <input
          type="hidden"
          id="ik_pm_no"
          name="ik_pm_no"
          value={interkassaOrderNumber || ""}
        />
        {/* Назва продукта */}
        <input
          type="hidden"
          name="ik_desc"
          value={interkassaProductName || ""}
        />
        <input type="hidden" name="ik_loc" value="uk_ua" />
        {/* Телефон */}
        <input type="hidden" name="ik_cli" value={phone || ""} />
        {/* Спосіб взаємодії: веб-форма чи JSON */}
        <input type="hidden" name="ik_int" value="web" />
        {/* Пошта для нового протоколу Інтеркаси/Tranzzo */}
        <input
          type="hidden"
          name="ik_customer_email"
          value={authUser?.email || ""}
        />
        {/* Контактні дані */}
        <input
          type="hidden"
          id="ik_customer_phone"
          name="ik_customer_phone"
          value={`${phone}:${authUser?.email || ""}`}
        />
        {/* Обраний пакет та контакти */}
        <input
          type="hidden"
          id="ik_customer_referrer"
          name="ik_customer_referrer"
          value={interkassaEncodedOrderData}
        />
        {/* Код платіжного напряму */}
        <input type="hidden" name="ik_act" value="process" />
        {/* URL для платежів */}
        <input
          type="hidden"
          id="ik_ia_u"
          name="ik_ia_u"
          value={globals?.payments?.ik_ia_u || ""}
        />
        {/* Interaction page request method */}
        <input
          type="hidden"
          id="ik_ia_m"
          name="ik_ia_m"
          value={globals?.payments?.ik_ia_m || ""}
        />
        {/* Сторінка успішної оплати */}
        <input
          type="hidden"
          id="ik_suc_u"
          name="ik_suc_u"
          value={globals?.payments?.ik_suc_u || ""}
        />
        <input
          type="hidden"
          id="ik_result_url"
          name="ik_result_url"
          value={globals?.payments?.ik_suc_u || ""}
        />
        <input
          type="hidden"
          id="ik_pnd_u"
          name="ik_pnd_u"
          value={globals?.payments?.ik_suc_u || ""}
        />
        {/* Сторінка неуспішної оплати (Fail Url) */}
        <input
          type="hidden"
          id="ik_fal_u"
          name="ik_fal_u"
          value={globals?.payments?.ik_fal_u || ""}
        />
        <Button
          text={products(globals)[orderPackage]?.buttonCaption}
          disabled={isLoading}
          type="button"
          onClick={() => handleSubmit()}
          className={`payment ${isLoading ? "" : "available"}`}
        />
      </form>
    </div>
  );
};

export default Order;
